import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Terms of Service</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <p>
              <strong>Last updated: September 8, 2026</strong>
            </p>

            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using the Petoutlet website and services, you
              agree to be bound by these Terms of Service and all applicable
              laws and regulations. If you do not agree with any of these terms,
              you are prohibited from using or accessing this site.
            </p>

            <h2>2. Use License</h2>
            <p>
              Permission is granted to temporarily access the materials on
              Petoutlet's website for personal, non-commercial transitory
              viewing only. This is the grant of a license, not a transfer of
              title, and under this license you may not:
            </p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>
                Use the materials for any commercial purpose or public display
              </li>
              <li>
                Attempt to reverse engineer any software contained on the
                website
              </li>
              <li>
                Remove any copyright or proprietary notations from the materials
              </li>
              <li>
                Transfer the materials to another person or "mirror" the
                materials on any other server
              </li>
            </ul>

            <h2>3. Disclaimer</h2>
            <p>
              The materials on Petoutlet's website are provided on an 'as is'
              basis. Petoutlet makes no warranties, expressed or implied, and
              hereby disclaims and negates all other warranties including,
              without limitation, implied warranties or conditions of
              merchantability, fitness for a particular purpose, or
              non-infringement of intellectual property.
            </p>

            <h2>4. Limitations</h2>
            <p>
              In no event shall Petoutlet or its suppliers be liable for any
              damages arising out of the use or inability to use the materials
              on Petoutlet's website, even if we have been notified of the
              possibility of such damage.
            </p>

            <h2>5. Accuracy of Materials</h2>
            <p>
              The materials appearing on Petoutlet's website could include
              technical, typographical, or photographic errors. Petoutlet does
              not warrant that any of the materials on its website are accurate,
              complete, or current.
            </p>

            <h2>6. Links</h2>
            <p>
              Petoutlet has not reviewed all of the sites linked to its website
              and is not responsible for the contents of any such linked site.
              The inclusion of any link does not imply endorsement by Petoutlet
              of the site.
            </p>

            <h2>7. Modifications</h2>
            <p>
              Petoutlet may revise these terms of service at any time without
              notice. By using this website, you are agreeing to be bound by the
              then current version of these terms of service.
            </p>

            <h2>8. Governing Law</h2>
            <p>
              These terms and conditions are governed by and construed in
              accordance with the laws of the Hong Kong Special Administrative
              Region. The courts of Hong Kong will have jurisdiction, subject to
              any rights you may have under mandatory consumer law.
            </p>

            <h2>9. Your Account</h2>
            <p>
              If you create an account on our website, you are responsible for
              maintaining the security of your account and for all activities
              that occur under your account. You agree to provide accurate and
              complete information when creating your account.
            </p>

            <h2>10. Product Information</h2>
            <p>
              We strive to display accurate product information, including
              pricing, descriptions, and availability. However, we do not
              warrant that product descriptions or other content is accurate,
              complete, reliable, current, or error-free.
            </p>

            <h2>11. Pricing</h2>
            <p>
              All prices are listed in Hong Kong Dollars (HKD) and are subject
              to change without notice. We reserve the right to refuse or cancel
              any orders placed for products listed at an incorrect price.
            </p>

            <h2>12. Shipping Policy</h2>
            <p>
              Shipping rates and delivery times vary by location and shipping
              method selected. Please refer to our{" "}
              <Link onClick={toTop} to="/shipping">
                Shipping Policy
              </Link>{" "}
              for more details.
            </p>

            <h2>13. Returns and Refunds</h2>
            <p>
              We accept returns within 30 days of purchase for most items.
              Please refer to our{" "}
              <Link onClick={toTop} to="/returns">
                Refund Policy
              </Link>{" "}
              for complete information about our return process.
            </p>

            <h2>14. Intellectual Property</h2>
            <p>
              The website and its original content, features, and functionality
              are owned by Petoutlet and are protected by international
              copyright, trademark, patent, trade secret, and other intellectual
              property laws.
            </p>

            <h2>15. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <p>
              <strong>Petoutlet Consumer Services</strong>
              <br />
              Email:{" "}
              <a href="mailto:audit@petoutlet.work">audit@petoutlet.work</a>
              <br />
              Phone: Available through our contact page
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
